export default __webpack_public_path__ + "static/media/Download.a4b8cb6c.svg";